var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "primary sidebar",
      attrs: {
        fixed: "",
        permanent: "",
        "mini-variant": true,
        "mini-variant-width": 80
      }
    },
    [
      _vm.authorized
        ? _c(
            "v-list",
            { staticClass: "sidebar-list", attrs: { "two-line": "" } },
            _vm._l(_vm.filteredMenuItems, function(item) {
              return _c(
                "v-list-item",
                {
                  key: item.title,
                  class: [
                    _vm.$route.path.includes(item.link) ? "selected" : "",
                    "list-item"
                  ],
                  attrs: { to: item.link }
                },
                [
                  _c(
                    "v-list-item-action",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { right: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "white--text link-icon",
                                            attrs: { large: "" }
                                          },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(_vm._s(item.icon))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v(_vm._s(item.title))])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c5cc5f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5cc5f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavDrawer.vue
// module id = VZjw
// module chunks = 1